import request from '../services/request';

export function search(data) {
  return request({
    url: `/stripe/list/subscriptions`,
    method: 'POST',
    data,
  });
}

export function searchSubscriptions(data, page) {
  return request({
    url: `/stripe/list/subscriptions?page=${page}`,
    method: 'POST',
    data,
  });
}

export function storeSubscription(data) {
  return request({
    url: `/stripe/update/subscriptions`,
    method: 'GET',
    data,
  });
}

export function deleteSubscription(id) {
  return request({
    url: `stripe/delete/payment/method/${id}`,
    method: 'DELETE',
  });
}

export function cancelSubscription(id) {
  return request({
    url: `stripe/cancel/subscription/${id}`,
    method: 'DELETE',
  });
}

export function statusSubscription(id, data) {
  return request({
    url: `/stripe/update/subscription/${id}`,
    method: 'PUT',
    data,
  });
}
